<template>
  <div>
    <div class="goback-large"><i class="fal fa-arrow-left c-pointer" @click="onBackToHomeButton"></i> E2E 등록 마법사</div>
    <el-steps :active="activeStep" finish-status="success">
      <el-step v-for="(step, index) in stepTitles" :key="index" :title="step"></el-step>
    </el-steps>
    <!-- E2E 서비스 등록 컴포넌트 -->
    <div v-show="activeStep === 1">
      <el-row type="flex" justify="space-between" class="title-bar">
        <div class="title-h4">E2E 서비스 정보 입력</div>
        <el-button type="primary" @click="onNextLayerButton">다음단계</el-button>
      </el-row>
      <hr class="mr-b20" style="margin-top: 0px;" />
      <el-row :gutter="15">
        <!-- E2E 서비스 form -->
        <el-col :span="12">
          <el-form :model="formData" :rules="formDataRules" ref="formData">
            <el-row :gutter="15" type="flex" class="mr-b30">
              <el-col :span="12">
                <el-form-item style="margin-top:0px;" prop="serviceName" label="E2E 서비스명">
                  <el-input size="small" v-model="formData.serviceName" placeholder="E2E 서비스 명을 입력해주세요"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item style="margin-top:0px;" label="프로토콜">
                  <el-select @change="onChangeProtocol" style="width: 100%;" size="small" v-model="formData.protocol">
                    <el-option v-for="item in protocolList" :key="item.basicinfoSubid" :label="item.basicinfoSubid" :value="item.basicinfoSubid"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 프로토콜 세부 설정 폼 -->
            <div class="title-h4" style="margin-bottom:5px;">프로토콜 세부 설정</div>
            <!-- http & https-->
            <el-form v-show="targetProtocol == 'HTTP' || targetProtocol == 'HTTPS'" :rules="httpRules" ref="http" :model="httpCombineForm">
              <el-form-item label="방식">
                <el-select size="small" style="width: 100%" v-model="httpCombineForm.method">
                  <el-option label="GET" value="GET"></el-option>
                  <el-option label="POST" value="POST"></el-option>
                </el-select>
              </el-form-item>
              <el-row>
                <el-form-item label="URL" prop="httpUrl">
                  <el-input placeholder="URL을 입력해주세요" size="small" v-model="httpCombineForm.httpUrl"></el-input>
                </el-form-item>
              </el-row>
              <el-form-item prop="httpParam" label="파라미터">
                <el-input placeholder="파라미터를 입력해주세요" size="small" v-model="httpCombineForm.httpParam"></el-input>
              </el-form-item>
              <el-row :gutter="15" type="flex">
                <el-col :span="12">
                  <el-form-item label="문자열 정합성 사용 유무" prop="httpAdjustType">
                    <el-select v-model="httpCombineForm.httpAdjustType" size="small" style="width: 100%;">
                      <el-option label="사용안함" value="N"></el-option>
                      <el-option label="해당 문자열이 있어야함" value="G"></el-option>
                      <el-option label="해당 문자열이 있으면 안됨" value="B"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="정합성 문자열" prop="httpAdjustText">
                    <el-input :disabled="httpCombineForm.httpAdjustType == 'N'" v-model="httpCombineForm.httpAdjustText" placeholder="문자열을 입력해주세요" size="small" style="width: 100%;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15" v-show="targetProtocol == 'HTTPS'" type="flex">
                <el-col :span="12">
                  <el-form-item label="HTTPS 인증서 사용 유무" prop="">
                    <el-select v-model="httpCombineForm.httpsCertificateUseFlag" size="small" style="width: 100%;">
                      <el-option label="사용안함" value="0"></el-option>
                      <el-option label="사용" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="HTTPS 인증서 이름" prop="httpsCertificateName">
                    <el-input :disabled="httpCombineForm.httpsCertificateUseFlag === '0'" v-model="httpCombineForm.httpsCertificateName" placeholder="문자열을 입력해주세요" size="small" style="width: 100%;"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <!-- FTP -->
            <el-form v-show="targetProtocol == 'FTP'" ref="ftp" :rules="ftpRules" :model="ftpForm">
              <el-form-item label="URL" prop="ftpUrl">
                <el-input size="small" v-model="ftpForm.ftpUrl" placeholder="FTP URL을 입력해주세요"></el-input>
              </el-form-item>
              <el-row :gutter="15" type="flex" justify="space-between">
                <el-col :span="12">
                  <el-form-item prop="ftpId" label="아이디">
                    <el-input size="small" v-model="ftpForm.ftpId" placeholder="아이디를 입력해주세요"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="ftpPw" label="패스워드">
                    <el-input size="small" type="password" v-model="ftpForm.ftpPw" placeholder="패스워드를 입력해주세요"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <!-- smtpForm -->
            <el-form v-show="targetProtocol == 'SMTP'" ref="smtp" :rules="smtpRules" :model="smtpForm">
              <el-form-item label="URL" prop="smtpUrl">
                <el-input size="small" v-model="smtpForm.smtpUrl" placeholder="SMTP URL을 입력해주세요"></el-input>
              </el-form-item>
              <el-row :gutter="15" type="flex" justify="space-between">
                <el-col :span="12">
                  <el-form-item label="메일 아이디" prop="mailerId">
                    <el-input size="small" v-model="smtpForm.mailerId" placeholder="아이디를 입력해주세요"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="메일 패스워드" prop="mailerPw">
                    <el-input size="small" type="password" v-model="smtpForm.mailerPw" placeholder="패스워드를 입력해주세요"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="15" type="flex" justify="space-between">
                <el-col :span="12">
                  <el-form-item label="암호방식" prop="smtpCipherType"></el-form-item>
                  <el-select size="small" style="width: 100%;" v-model="smtpForm.smtpCipherType">
                    <el-option v-for="item in smtpCipherTypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="메일 전송유무" prop="smtpSenderApplyFlag"></el-form-item>
                  <el-switch style="width: 100%; margin-top: 5px;" v-model="smtpForm.smtpSenderApplyFlag" active-value="1" inactive-value="0"></el-switch>
                </el-col>
              </el-row>
            </el-form>
            <!-- pop3Form -->
            <el-form v-show="targetProtocol == 'POP'" :rules="popRules" :model="pop3Form" ref="pop">
              <el-form-item label="POP URL" prop="popUrl">
                <el-input v-model="pop3Form.popUrl" placeholder="POP URL을 입력해주세요"></el-input>
              </el-form-item>
              <el-form-item label="SSL 사용 유무"></el-form-item>
              <el-select v-model="pop3Form.popSslUseFlag">
                <el-option label="사용안함" value="0"></el-option>
                <el-option label="사용" value="1"></el-option>
              </el-select>
            </el-form>
          </el-form>
        </el-col>
        <!-- DB -->
        <el-col :span="12">
          <w-e2e-db-setting-form ref="dbSettingForm" style="width:100%;" :form-data="formDbSettingData" :service-info="serviceInfo" v-show="targetProtocol == 'HTTP' || targetProtocol == 'HTTPS'"></w-e2e-db-setting-form>
          <w-e2e-mail-setting-form style="width:100%;" :form-data="smtpForm" v-show="targetProtocol == 'SMTP'"></w-e2e-mail-setting-form>
        </el-col>
      </el-row>
    </div>
    <!-- 에이전트 연결 컴포넌트 -->
    <w-e2e-regist-wizard-for-agent
      ref="wizardForAgent"
      v-show="activeStep === 2"
      :targetTransactionId="targetTransactionId"
      :wizardMode="wizardMode"
      :agentData="agentData"
      @on-back-layer-button="onBackLayerButton"
      @on-e2e-regist-button="onE2eRegistButton"
    ></w-e2e-regist-wizard-for-agent>
  </div>
</template>

<script>
import { isNil, assign, merge, isEmpty, forEach, cloneDeep, has } from 'lodash';
import msgUtil from '@/utils/message';
import basicinfoSubAPI from '@/api/model/basicinfo-sub';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
import DeviceRegistrationE2eApi from '@/api/settings/common/device-registration-e2e';
import WE2eDbSettingForm from './components/E2eDbSettingForm';
import WE2eMailSettingForm from './components/E2eMailSettingForm';
import WE2eRegistWizardForAgent from './E2eRegistWizardForAgent';

export default {
  name: 'WE2eRegistWizard',
  props: {
    wizardMode: {
      type: String,
    },
    agentData: Array,
  },
  components: {
    WE2eDbSettingForm,
    WE2eMailSettingForm,
    WE2eRegistWizardForAgent,
  },
  data() {
    return {
      // 기본 form
      formData: {
        serviceName: '',
        protocol: 'HTTP',
      },
      formDataRules: {
        serviceName: {
          required: true,
          trigger: 'blur',
          message: 'E2E 서비스 명을 입력해주세요',
        },
      },
      httpRules: {
        httpUrl: {
          required: true,
          trigger: 'blur',
          message: 'URL을 입력해주세요',
        },
      },
      ftpRules: {
        ftpUrl: {
          required: true,
          trigger: 'blur',
          message: 'FTP URL을 입력해주세요',
        },
      },
      smtpRules: {
        smtpUrl: {
          required: true,
          trigger: 'blur',
          message: 'SMTP URL을 입력해주세요',
        },
      },
      popRules: {
        popUrl: {
          required: true,
          trigger: 'blur',
          message: 'POP URL을 입력해주세요',
        },
      },
      protocolList: [],
      smtpCipherTypeList: [],
      targetProtocol: 'HTTP',
      // HTTP & HTTPS form
      httpCombineForm: {
        method: 'GET',
        httpUrl: '',
        httpParam: '',
        httpAdjustType: 'N', // N,G,B
        httpAdjustText: '',
        // HTTPS 추가필드
        httpsCertificateUseFlag: '0',
        httpsCertificateName: '',
      },
      // DB 세팅 form
      formDbSettingData: {
        dbSettingFlag: false,
        dbSettingId: null,
        dbSql: null,
      },
      // FTP form
      ftpForm: {
        ftpUrl: '',
        ftpId: '',
        ftpPw: '',
        ftpTestType: 'N',
      },
      // SMTP form
      smtpForm: {
        smtpUrl: '',
        smtpSenderApplyFlag: '0',
        mailerId: '',
        mailerPw: '',
        smtpSenderId: '',
        smtpReceiverId: '',
        smtpCipherType: 'NONE',
        smtpContext: '',
        smtpCcId: '', // 참조
      },
      // POP3 form
      pop3Form: {
        popUrl: '',
        popSslUseFlag: '0',
      },
      targetTransactionId: 0,
      activeStep: 1,
      stepTitles: ['E2E 서비스 등록', 'E2E 에이전트 연결'],
      serviceInfo: {},
    };
  },
  mounted() {
    // protocol api
    basicinfoSubAPI.getList('E2E_PROTOCOL').then((response) => {
      if (response.data.success) {
        this.protocolList = response.data.data;
      }
    });
    // mail-cipher-type
    basicinfoSubAPI.getList('SMTP_CIPER_TYPE').then((response) => {
      if (response.data.success) {
        this.smtpCipherTypeList = response.data.data;
      }
    });
  },
  methods: {
    onBackToHomeButton() {
      this.$emit('on-back-layer-button');
      this.activeStep = 1;
    },
    // 다음단계 버튼 클릭 > 해당 form 유효성 검사
    onNextLayerButton() {
      const checkValidation = [];
      checkValidation.push(
        new Promise((resolve, reject) => {
          this.$refs.formData
            .validate()
            .then((res) => {
              resolve(res);
            })
            .catch(() => {
              reject(false);
            });
        }),
      );
      if (this.formDbSettingData.dbSettingFlag === true) {
        checkValidation.push(
          new Promise((resolve, reject) => {
            this.$refs.dbSettingForm
              .getForm()
              .validate()
              .then((res) => {
                resolve(res);
              })
              .catch(() => {
                reject(false);
              });
          }),
        );
      }

      Promise.all(checkValidation)
        .then(() => {
          // 다음 단계 이동
          this.$nextTick(() => {
            this.$refs.wizardForAgent.onSettingAgentList();
            this.activeStep = 2;
          });
        })
        .catch(() => {});
      // 기본정보 (E2E서비스명, 프로토콜) 유효성 검사
      // this.$refs.formData
      //   .validate()
      //   .then(() => {
      //     this.$refs[this.targetProtocol === 'HTTPS' ? 'http' : lowerCase(this.targetProtocol)]
      //       .validate()
      //       .then(() => {
      //         // 다음 단계 이동
      //         this.$nextTick(() => {
      //           this.$refs.wizardForAgent.onSettingAgentList();
      //           this.activeStep = 2;
      //         });
      //       })
      //       .catch(() => {});
      //   })
      //   .catch(() => {});
    },
    onBackLayerButton() {
      this.activeStep = 1;
    },
    // 등록 마법사 최종 저장 이벤트
    onE2eRegistButton(selectedAgents) {
      if (this.targetProtocol === 'HTTP' || this.targetProtocol === 'HTTPS') {
        // http일경우 보안 인증 데이터 삭제
        if (this.targetProtocol === 'HTTP') {
          delete this.httpCombineForm.httpsCertificateUseFlag;
          delete this.httpCombineForm.httpsCertificateName;
        }
        // 문자열 정합성
        if (this.httpAdjustType === 'N') {
          delete this.httpCombineForm.httpAdjustText;
        }
        // HTTPS 인증서
        if (this.httpsCertificateUseFlag === '0') {
          delete this.httpCombineForm.httpsCertificateName;
        }
        // DB setting
        if (this.formDbSettingData.dbSettingFlag) {
          if (isNil(this.formDbSettingData.dbSettingId)) {
            this.formDbSettingData.dbSettingId = null;
            this.formDbSettingData.dbSql = null;
          }
        } else {
          this.formDbSettingData.dbSettingId = null;
          this.formDbSettingData.dbSql = null;
        }
        merge(this.formData, this.formDbSettingData);
        merge(this.formData, this.httpCombineForm);
      } else if (this.targetProtocol === 'FTP') {
        merge(this.formData, this.ftpForm);
      } else if (this.targetProtocol === 'SMTP') {
        merge(this.formData, this.smtpForm);
      } else {
        // POP
        merge(this.formData, this.pop3Form);
      }
      // 전달 formData에 선택한 agentList들도 포함시켜 전달하여 한꺼번에 처리한다.
      const agentList = [];
      if (!isEmpty(selectedAgents)) {
        forEach(selectedAgents, (agent) => {
          agentList.push({
            agentId: agent.agentId,
            objId: agent.objId,
          });
        });
      }
      this.formData.agentList = agentList;
      const target = 'E2E 서비스';
      const action = msgUtil.action.SAVE;
      const encryptTargetData = createEncryptTargetData(this.formData, ['ftpPw', 'mailerPw']);
      if (encryptTargetData !== null) {
        getRsaEncrypt(encryptTargetData)
          .then((encryptData) => {
            const params = assign(cloneDeep(this.formData), encryptData);
            if (has(encryptData, 'ftpPw')) {
              params.ftpId = this.formData.ftpId;
            }
            if (has(encryptData, 'mailerPw')) {
              params.mailerId = this.formData.mailerId;
            }
            this.save(params, action, target);
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
            throw new Error(e);
          });
      } else {
        this.save(this.formData, action, target);
      }
    },
    /**
     * E2E 서비스를 저장한다.
     * @param  {[type]} params [description]
     * @param  {[type]} action [description]
     * @param  {[type]} target [description]
     * @return {[type]}        [description]
     */
    save(params, action, target) {
      if (this.wizardMode === 'add') {
        DeviceRegistrationE2eApi.insertTransactionSvc(params).then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.$emit('load-data');
            this.activeStep = 1;
            this.onResetFormFields();
            this.onBackToHomeButton();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        });
      } else {
        DeviceRegistrationE2eApi.updateTransactionSvcByWizard(params)
          .then((response) => {
            const result = response.data;
            if (result.success === true) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.$emit('load-data');
              this.activeStep = 1;
              this.onResetFormFields();
              this.onBackToHomeButton();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      }
    },
    // 프로토콜 select 이벤트
    onChangeProtocol(value) {
      this.targetProtocol = value;
      // 모든 form rule 및 값 초기화
      // this.$nextTick(() => {
      //   this.onResetFormFields();
      // });
    },
    // 모든 form들을 초기화시킨다.
    onResetFormFields() {
      // if (this.wizardMode === 'add') {
      //   this.$refs.formData.resetFields();
      // }
      this.$refs.formData.resetFields();
      this.$refs.http.resetFields();
      this.$refs.ftp.resetFields();
      this.$refs.smtp.resetFields();
      this.$refs.pop.resetFields();
      // DB-Settings
      this.formDbSettingData = {
        dbSettingFlag: false,
        dbSettingId: null,
        dbSql: null,
      };
      this.formData = {
        serviceName: null,
        protocol: 'HTTP',
      };
      this.targetProtocol = 'HTTP';
    },
    /**
     * E2E 서비스의 상세 정보를 조히하여 화면에 설정한다.
     * @param  {[type]} objId [description]
     * @return {[type]}       [description]
     */
    onSettingByWizardMode(objId) {
      this.onResetFormFields();
      if (!isNil(objId)) {
        const action = msgUtil.action.VIEW;
        const target = 'E2E 서비스';
        DeviceRegistrationE2eApi.getE2eTransactionSvct(objId)
          .then((response) => {
            if (response.data.success) {
              const row = response.data.data;
              this.serviceInfo = {};
              if (this.wizardMode === 'update') {
                this.serviceInfo = row;
                this.targetTransactionId = row.transactionId;
                this.formData.serviceName = row.serviceName;
                this.formData.transactionId = row.transactionId;
                this.formData.serviceId = row.serviceId;
                this.formData.objId = row.objId;
                this.formData.protocol = row.protocol;
                this.targetProtocol = row.protocol;
                if (row.protocol === 'HTTP' || row.protocol === 'HTTPS') {
                  this.httpCombineForm.method = row.method;
                  this.httpCombineForm.httpUrl = row.httpUrl;
                  this.httpCombineForm.httpParam = row.httpParam;
                  this.httpCombineForm.httpAdjustType = row.httpAdjustType;
                  this.httpCombineForm.httpAdjustText = row.httpAdjustText;

                  if (row.protocol === 'HTTPS') {
                    this.httpCombineForm.httpsCertificateUseFlag = row.httpsCertificateUseFlag;
                    this.httpCombineForm.httpsCertificateName = row.httpsCertificateName;
                  }
                  // DB-Settings
                  if (row.dbSettingId) {
                    this.formDbSettingData.dbSettingFlag = true;
                    this.formDbSettingData.dbSettingId = row.dbSettingId;
                    this.formDbSettingData.dbSql = row.dbSql;
                  }
                } else if (row.protocol === 'FTP') {
                  // Protocol - ftp
                  this.ftpForm.ftpUrl = row.ftpUrl;
                  this.ftpForm.ftpId = row.ftpId;
                  this.ftpForm.ftpPw = row.ftpPw;
                  this.ftpForm.ftpTestType = row.ftpTestType;
                } else if (row.protocol === 'SMTP') {
                  // Protocol - smtp
                  this.smtpForm.smtpUrl = row.smtpUrl;
                  this.smtpForm.smtpSenderApplyFlag = row.smtpSenderApplyFlag;
                  this.smtpForm.mailerId = row.mailerId;
                  this.smtpForm.mailerPw = row.mailerPw;
                  this.smtpForm.smtpSenderId = row.smtpSenderId;
                  this.smtpForm.smtpReceiverId = row.smtpReceiverId;
                  this.smtpForm.smtpCipherType = row.smtpCipherType;
                  this.smtpForm.smtpContext = row.smtpContext;
                  this.smtpForm.smtpCcId = row.smtpCcId;
                } else {
                  // Protocol - pop
                  this.pop3Form.popUrl = row.popUrl;
                  this.pop3Form.popSslUseFlag = row.popSslUseFlag;
                }
              } else {
                // wizardMode = 'add'
                this.targetProtocol = 'HTTP';
                this.formData.protocol = 'HTTP';
              }
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
            throw new Error(e);
          });
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/E2eDevice/E2eRegistWizard.vue